import IcnCarotRight from 'public/assets/icons/carot-right.svg';
import { Icon } from 'components/icon/icon';
import { LinkFieldsFragment } from 'api/graphql-types';

import styles from './woo-link.module.scss';

export type WooLinkProps = {
	link: LinkFieldsFragment;
};

const WooLink = (props: WooLinkProps): React.JSX.Element => (
	<a href={props.link.href.url} className={styles.link}>
		<div className={styles.text}>
			<span className={styles.title}>{props.link.title}</span>
			<span className={styles.description}>{props.link.description}</span>
		</div>
		<Icon customIcon={<IcnCarotRight />} size="12px" />
	</a>
);

export default WooLink;
